import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
import { CTAButton } from './CTAButton';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-plum/10 bg-cream" data-id="element-16" data-mp="avl8q8kv4hi1">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "17px",
      paddingBottom: "12px"
    }} data-id="element-17" data-mp="ftwlos6gf84h">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="1tvktcq6w0p0">
          🎁 5 professional bonuses included
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-grape" data-id="element-19" data-mp="5xbfw4mm1szl">
          Five extra resources to complete your toolkit
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3t1hhumiel4ww">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`relative flex gap-4 rounded-2xl border border-plum/10 bg-white p-5 ${i === bonuses.length - 1 && bonuses.length % 2 === 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-0.625rem)]' : ''}`} data-id="element-21" data-mp="1m9ywldfm8wy2" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="h-auto w-24 shrink-0 self-start object-contain drop-shadow-[0_10px_18px_rgba(10,10,10,0.35)] sm:w-28" data-id="element-22" data-mp="3n4mwx5wyhvk5" />
              <div className="flex min-w-0 flex-1 flex-col" data-id="element-23" data-mp="2uibtlnhytgjn">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="38gijohgoac8r">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-plum px-3 py-1 text-xs font-bold text-grape-soft" data-id="element-25" data-mp="33gnrmal5vgm4">
                    <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-26" data-mp="ns4bqd4poebe" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="itauc9mb035y">
                    <span className="text-plum/40 line-through" data-id="element-28" data-mp="3cin00ys8h6bv">{b.price}</span>{' '}
                    <span className="text-grape" data-id="element-29" data-mp="3hgofzaud4pj4">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-black uppercase leading-snug text-plum" data-id="element-30" data-mp="3lk4dsai64vxe">{b.title}</h3>
                <p className="mt-1 text-sm font-semibold text-grape-deep" data-id="element-31" data-mp="3qi5vos3uyp7a">{b.tagline}</p>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="2ttq3spda03r0">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        
      </div>
    </section>;
}